import React from 'react';
import { useSelector } from 'react-redux';
import { Loading } from '@guryou/html-components';
import { stateIsLoaded } from '@guryou/redux';
import Header from './header';
import SubHeader from './SubHeader';
import Sidebar from './Sidebar';

const TopNavigation = () => {
  const auth = useSelector(state => state.auth);
  const isLoggedIn = stateIsLoaded(auth) && !!auth?.data;

  if (isLoggedIn) {
    return (
      <>
        <Loading />
        <Sidebar />
      </>
    );
  }

  return (
    <>
      <Loading />
      <Header />
      <SubHeader />
    </>
  );
};

export default TopNavigation;
